export default [
    {
        num: 1,
        label: {
            en: 'Piece',
            et: 'Tükk',
            ru: 'Штука',
            lv: "Gabals",
            lt: "Vienetas",
            fi: "Kappale",
        }
    },
    {
        num: 2,
        label: {
            en: 'Meter',
            et: 'Meeter',
            ru: 'Метр',
            lv: "Metrs",
            lt: "Metras",
            fi: "Metri",
        }
    },
    {
        num: 3,
        label: {
            en: 'Liter',
            et: 'Liiter',
            ru: 'Литр',
            lv: "Litrs",
            lt: "Litras",
            fi: "Litra",
        }
    },
    {
        num: 4,
        label: {
            en: 'Gram',
            et: 'Gramm',
            ru: 'Грамм',
            lv: "Grams",
            lt: "Gramas",
            fi: "Gramma",
        }
    }
]
